var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDislikeGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.81V2h10.662L15 10.048l-7.068.371L8 15H5.833l-1.641-4.581L2.5 8.809zM13.667 5H12.5M14 7h-1M.5 1.5V9",
    stroke: "#B3B4C3"
  })));
}
export default SvgIconDislikeGray;